export function monkeyPatchFragmentLoadMethod(hlsPlayer: any, ): void {
	if (hlsPlayer.isFragLoadWorker) {
		['main', 'audio', 'subtitle']
			.forEach(playlist => {
				const fragmentLoader = hlsPlayer.player.networkControllers.find(controller => controller.playlistType === playlist).fragmentLoader;
				if (!fragmentLoader) {
					return;
				}
				monkeyPatchLoadMethod(fragmentLoader);
			});
	}
}

function monkeyPatchLoadMethod(fragmentLoader: any) {
	const originalFunction = fragmentLoader.load;
	fragmentLoader.load = function(...args: any[]) {
		const frag = args[0];
		this.config.fragType = frag.type;
		return originalFunction.apply(this, args);
	};
}
